import { FormControl, FormDescription, FormItem, FormMessage, useFormField } from "@ui/shad"
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form"

import { TextInput } from "../inputs/text-input"

function formatSsn(value: string) {
  const digits = value.replace(/\D/g, "").slice(0, 9)
  if (digits.length <= 3) return digits
  if (digits.length <= 5) return `${digits.slice(0, 3)}-${digits.slice(3)}`
  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`
}

interface TypedSsnFieldProps<T extends FieldValues>
  extends Omit<React.ComponentProps<typeof TextInput>, "value" | "onChange" | "onBlur" | "ref"> {
  id: string
  description?: string
  field: ControllerRenderProps<T, Path<T>>
}

export function TypedSsnField<T extends FieldValues>({ field, id, description, ...props }: TypedSsnFieldProps<T>) {
  const { error } = useFormField()
  const value = typeof field.value === "string" ? formatSsn(field.value) : ""

  return (
    <FormItem>
      <FormControl>
        <TextInput
          {...props}
          {...field}
          id={id}
          value={value}
          onChange={(event) => field.onChange(event.target.value.replace(/\D/g, "").slice(0, 9))}
          error={!!error}
          inputMode="numeric"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck={false}
          maxLength={11}
        />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  )
}
